import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, unref as _unref, isRef as _isRef, withCtx as _withCtx, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-aec7e926"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "person-selector" }
const _hoisted_2 = {
  key: 0,
  class: "selected-person"
}
const _hoisted_3 = { key: 1 }

import { computed, nextTick, ref } from 'vue'
import { AsyncFilter } from '@/util/LiveSearch'
import { useLivePersonSearch } from '@/rd/LivePersonSearch'
import { ViewPerson } from '@/rd/ResearchDataModel'
import PersonCard from './PersonCard.vue'
import SearchInput from "@/util/SearchInput.vue"
import PersonListItem from './PersonListItem.vue'


export default /*#__PURE__*/_defineComponent({
  __name: 'PersonSelector',
  props: {
    modelValue: {},
    placeholder: {},
    disabled: { type: Boolean },
    postFilter: { type: Function }
  },
  emits: [
  'update:modelValue',
  'focus'
],
  setup(__props: any, { expose: __expose, emit }) {

const props = __props;





__expose({
  focus: () => searchInputRef.value?.focus(),
  reset
})

const placeholderRef = computed(() => props.placeholder ?? "Type a name")

const { searchTextRef, searchResultsRef } = useLivePersonSearch(props.postFilter)

const removeButtonRef = ref<HTMLButtonElement>()
const searchInputRef = ref<InstanceType<typeof SearchInput>>()

async function searchResultSelected(id: string) {
  emit('update:modelValue', id)
  await nextTick()
  removeButtonRef.value?.focus()
}

async function removeSelectedPerson() {
  emit('update:modelValue', undefined)
  await nextTick()
  searchInputRef.value?.focus()
}

function reset() {
  searchTextRef.value = ""
  searchInputRef.value?.reset()
}


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_ctx.modelValue)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _createVNode(PersonCard, {
            "person-id": _ctx.modelValue,
            layout: "small",
            "show-profile-type": "",
            "select-mode": "",
            "no-hover": "",
            disabled: _ctx.disabled,
            onClick: removeSelectedPerson
          }, null, 8, ["person-id", "disabled"])
        ]))
      : (_openBlock(), _createElementBlock("div", _hoisted_3, [
          _createVNode(SearchInput, {
            ref_key: "searchInputRef",
            ref: searchInputRef,
            modelValue: _unref(searchTextRef),
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (_isRef(searchTextRef) ? (searchTextRef).value = $event : null)),
            "search-results": _unref(searchResultsRef),
            placeholder: placeholderRef.value,
            disabled: _ctx.disabled,
            onFocus: _cache[1] || (_cache[1] = ($event: any) => (emit('focus'))),
            onResultSelected: searchResultSelected
          }, {
            default: _withCtx(({ item }) => [
              _createVNode(PersonListItem, {
                person: (item as ViewPerson)
              }, null, 8, ["person"])
            ]),
            _: 1
          }, 8, ["modelValue", "search-results", "placeholder", "disabled"])
        ]))
  ]))
}
}

})